import { render, staticRenderFns } from "./AuthenticatorHeader.vue?vue&type=template&id=058067e2&scoped=true"
import script from "./AuthenticatorHeader.vue?vue&type=script&lang=ts"
export * from "./AuthenticatorHeader.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticatorHeader.vue?vue&type=style&index=0&id=058067e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058067e2",
  null
  
)

export default component.exports